export default __webpack_public_path__ + "static/media/tail_of_boreas.6078d852.png";